(() => {
  const initCartLocationValidation = () => {
    const picker = document.querySelector('[data-fm-location-picker]');
    const form = picker && picker.closest('form');
    const checkout = form && form.querySelector('.fm-cart__checkout');
    const error = picker && picker.querySelector('[data-location-error]');
    const radios = picker ? [...picker.querySelectorAll('input[name="attributes[Delivery Location Type]"]')] : [];

    if (!picker || !form || !checkout || !radios.length || checkout.dataset.fmMobileUxValidation) return;
    checkout.dataset.fmMobileUxValidation = 'true';

    const clearError = () => {
      if (error) {
        error.textContent = '';
        error.hidden = true;
      }
      radios.forEach((radio) => radio.removeAttribute('aria-invalid'));
    };

    const showError = (event) => {
      if (radios.some((radio) => radio.checked)) return false;

      if (event) event.preventDefault();
      if (error) {
        error.textContent = 'Please choose a delivery location type before checkout.';
        error.hidden = false;
      }
      radios.forEach((radio) => radio.setAttribute('aria-invalid', 'true'));
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => radios[0].focus({ preventScroll: true }), 250);
      return true;
    };

    radios.forEach((radio) => radio.addEventListener('change', clearError));
    checkout.addEventListener('click', showError);
    form.addEventListener('invalid', (event) => {
      if (radios.includes(event.target)) showError(event);
    }, true);
  };

  const init = () => {
    initCartLocationValidation();
    const page = document.querySelector('.fm-product-page');
    const form = page && page.querySelector('.fm-product-form');
    const mobile = window.matchMedia('(max-width: 620px)');

    if (!page || !form || !mobile.matches) return;

    const extras = form.querySelector('.fm-extras');
    if (extras && !extras.closest('.fm-mobile-extras-disclosure')) {
      const details = document.createElement('details');
      details.className = 'fm-mobile-extras-disclosure';

      const summary = document.createElement('summary');
      summary.innerHTML =
        '<span class="fm-mobile-extras-copy">' +
          '<strong>Make It Extra Special</strong>' +
          '<small>Optional gifts & finishing touches</small>' +
        '</span>' +
        '<span class="fm-mobile-extras-icon" aria-hidden="true">+</span>';

      extras.before(details);
      details.append(summary, extras);
    }


  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();


/* FM_COLLECTION_HERO_READ_MORE_2026_08_21 */
(function () {
  var selector = '[id^="fm-collection-"] .fm-hero__description';
  var mobileQuery = window.matchMedia('(max-width: 767px)');

  function initializeCollectionDescriptions(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(selector).forEach(function (description, index) {
      if (description.dataset.fmCollectionReadMore === 'true') return;

      description.dataset.fmCollectionReadMore = 'true';

      var section = description.closest('[id^="fm-collection-"]');
      if (!description.id) {
        description.id = (section ? section.id : 'fm-collection') + '-description-' + index;
      }

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'fm-collection-description-toggle';
      button.textContent = 'READ MORE';
      button.setAttribute('aria-controls', description.id);
      button.setAttribute('aria-expanded', 'false');
      button.hidden = true;
      description.insertAdjacentElement('afterend', button);

      function syncVisibility() {
        if (!mobileQuery.matches) {
          button.hidden = true;
          return;
        }

        if (description.classList.contains('is-expanded')) {
          button.hidden = false;
          return;
        }

        button.hidden = !(description.scrollHeight > description.clientHeight + 2);
      }

      button.addEventListener('click', function () {
        var expanded = description.classList.toggle('is-expanded');
        button.textContent = expanded ? 'READ LESS' : 'READ MORE';
        button.setAttribute('aria-expanded', String(expanded));

        if (!expanded) {
          description.scrollIntoView({ block: 'nearest' });
        }

        window.requestAnimationFrame(syncVisibility);
      });

      window.requestAnimationFrame(syncVisibility);
      window.addEventListener('resize', syncVisibility, { passive: true });
    });
  }

  function initialize() {
    initializeCollectionDescriptions(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeCollectionDescriptions(event.target);
  });
})();
